import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useCard } from "../context/card.js";
import toast from "react-hot-toast";
import "../styles/ProductDetails.css";

const ProductDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState({});

  const [relatedProduct, setRelatedProduct] = useState([]);
  const [card, setCard] = useCard();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (params?.slug) getProduct();
  }, [params?.slug]);

  //get products
  const getProduct = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/product/getProductBySlug/${params.slug}`
      );
      setProducts(data?.product);

      getSimilarProduct(data?.product._id, data?.product.category._id);
    } catch (error) {
      console.log(error);
    }
  };

  //get similar or related product

  const getSimilarProduct = async (pid, cid) => {
    try {
      const { data } = await axios.get(
        `/api/v1/product/related-product/${pid}/${cid}`
      );

      setRelatedProduct(data?.product);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Layout>
      <div className="row container mt-4 product-details">
        <div className="col-md-6">
          <img
            src={`/api/v1/product/product-photo/${products._id}`}
            className="card-img-top"
            alt={products.name}
            height={"380px"}
          />
        </div>
        <div className="col-md-6 product-details-info">
          <h2 className=" text-center">Product Details</h2>
          <div className="container mt-4" style={{ paddingLeft: "200px" }}>
            <h6>Name : {products.name}</h6>
            <h6>Description : {products.description}</h6>
            <h6>Category : {products.category?.name}</h6>
            <h6>Price : RS.{products.price}</h6>
            <h6>Quantity : {products.quantity}</h6>
            <h6>
              Shipping :
              {products.shipping ? "Free Shipping" : "Shipping Charges Apply"}
            </h6>

            <button
              className="btn btn-warning ms-1 mt-4"
              onClick={() => {
                setCard([...card, products]);
                localStorage.setItem(
                  "cart",
                  JSON.stringify([...categories, products])
                );
                toast.success("Item Added to Cart Successfully");
              }}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
      <hr />

      <div className="row mt-5 me-4   similar-products">
        <h2 className="text-center">Similar Products</h2>
        {relatedProduct.length < 1 && (
          <p className="text-center " style={{ color: "red" }}>
            No Similar Product Found !
          </p>
        )}

        <div className="d-flex flex-wrap ml" style={{ paddingLeft: "100px" }}>
          {relatedProduct?.map((item) => (
            <div className="card m-2" key={item._id} style={{ width: "20rem" }}>
              <img
                src={`/api/v1/product/product-photo/${item._id}`}
                className="card-img-top"
                alt={item.name}
              />

              <div className="card-body">
                <h5 className="card-title">{item.name}</h5>
                <p className="card-text">{item.description.substring(0, 30)}</p>
                <p className="card-title card-price">Rs. {item.price}</p>
                <div className="card-name-price">
                  <button
                    className="btn btn-info ms-1"
                    onClick={() => {
                      navigate(`/product/${item.slug}`);
                    }}
                  >
                    More Details
                  </button>

                  {/* <button
                    className="btn btn-warning ms-1"
                    onClick={() => {
                      setCard([...card, item]);
                      localStorage.setItem(
                        "cart",
                        JSON.stringify([...categories, item])
                      );
                      toast.success("Item Added to Cart Successfully");
                    }}
                  >
                    Add to Cart
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default ProductDetails;
